<template>
    <div>
    <h2> Ancient Prison:</h2>
    Download Annotated Map:
    <a @click="$emit('downloadImg','Ancient Prison')">Download</a><br/>
    Download Clean Map 1:
    <a href="https://s3.amazonaws.com/files.d20.io/images/261080047/bR00E-U6pTbeYdlVoawxkw/original.jpg?164002413355" target=”_blank”>Map 1</a><br/>
    Download Clean Map 2:
    <a href="https://s3.amazonaws.com/files.d20.io/images/261079274/4KLJYODg5F0BeM63C6CRTg/original.jpg?164002372555" target=”_blank”>Map 2</a><br/>
    The Ancient Prison is a final encounter. It is arena style, so monsters will spawn one after another.
    <v-row>
        <v-col>
            <img id="Ancient Prison" :src="require('../../../assets/Annotated_Ancient_Prison_Map.png')"  contain height="942px"/>
        </v-col>
        <v-col>
        <h4>Map Details: </h4>
        <ul>
            <li>This encounter takes place in a ruin on the prime material plane</li>
            <li>The area is barely lit and players can see 20 feet around them, however the torches in this are give light in a 20 foot radius, and dim light 20 feet after that.</li>
            <li>The ceiling is 60 feet tall in the main room, and 15 feet in the rooms in the north.</li>
            <li>When players enter the map they can make a DC 24 perception check to hear the sound of chanting coming from the wall to the south that is slowly getting louder. If players spend more than 3 rounds navigating the tunnels then the chanting gets louder and sounds like it is coming to a climax, 2 rounds after that the ritual in the center room completes, remove the couatl sunlord from the map and begin wave 2 immediately, and increase the DC of all Tzitzimitl's abilities by 4 and it gains +4 to attack and damage. Players do not get experience for the Couatl sunlord if it dies this way.</li>
            <li>Once players have been on this encounter for 1 hour (real time) players receive 6d6 negative energy damage from the lingering aura of Tzitzimitl, but can make a will save DC 19 to reduce the damage by half. Every 10 minutes after that they must make the save again, but the DC increases by 4 and the damage increases by 6d6 each time they have had to make it. Characters immune to negative enery take 1d4 points of constitution damage instead and gain +8 to their save.</li>
            <li>This map is a phased map, and once players begin Tzitzimitl fight you should swap map to the second one if able. Its mostly to make the battle more interesting, not because its necessary.</li>
            <li>Map is 28x28</li>
            <li><b>Color Code:</b></li>
            <ul>
                <li>Player Spawn: Pink</li>
                <li>Treasure: Gold</li>
                <li>Monsters and Spawnpoints: Red</li>
                <li>Areas of interest: Green</li>
            </ul>
        </ul>
        <br/><br/>             
                
        </v-col>
    </v-row>
    <h4>Monsters:</h4>
        <ul>
            <li><b>Wave 1 CR 17: </b> </li>
            First wave appears the moment players enter arena. 
            <ul>
                <li><b>1) Couatl Sun Lord Warrior CR 15: </b></li>
                <li><b>2) Hallow Serpent CR 16: </b> </li>
            </ul>            
            <br/>
            <li><b>Wave 2 CR 19: </b> </li>
            Wave 2 begins after either monster in wave 1 is defeated. On the first round swap map to background 2, and all players standing in the water must make a reflex check dc 22 or be knocked prone and dragged 15 feet towards the center platform. Afterwards when moving in the water players must make an acrobatics check DC 15 or the water is considered difficult terrain. If they roll below 5 on the acrobatics check they are moved 15 feet towards the center platform. those movement provokes attacks of opportunity. 
            <ul>
                <li><b>1) Tzitzimitl: </b> Tzitzimitl appears from spawnpoint 1. Tzitzimitl viewed entire first combat and is therefor aware of all abilities party used in the first combat. Tzitzimitl enters having already cast haste. Tzitzimitl hitpoints become 594, gains 6 mythic points and gains the following abilities:
                <ul>
                    <li><b>Mythic Status Resistance: </b> 1pt, when he is affected by any negative status he wants to ignore he can spend a mythic point to completely negate it, this is not an action and can be done whenever he so chooses. This can negate any negative status, even grappling (but not death)</li>
                    <li><b>Mythic Spell Casting: </b> He can spend a mythic point to cast any spell level 5 or below, if it is a level 2 or below spell he can spend an additional mythic points to make the spell quickened. Once per spell he can spend a mythic point to increase the DC by 1d6.</li>
                    <li><b>Mythic Light to Dark: </b> For 2 mythic points Tzitzimitl's light to dark ability can target a positive energy effect within 100 feet and turn it into negative energy even if it doesn't target him.</li>
                </ul>
                </li>
            </ul>
            <br/>           
        </ul>
        <br/><br/>   

        <h4>Treasure:</h4>
        <ul>
            <li><b>1) L+ Weapon Enchantment 125: </b> Appears if players succeed AoI2 check.</li>
            <li><b>2) Resurrective 75</b></li>
            <li><b>3) 3 Spells/Maneuvers 100</b></li>
            <li><b>4) E+ Armor Enchantment 125</b></li>
            <li><b>5) E+ Weapon Enchantment 125</b></li>
            <li><b>6) lvl+ Spell/Maneuver 40</b></li>
            <li><b>7) Double Typed Maneuver 40 </b></li>
            <li><b>8) Typed Spell/Maneuver 40</b></li>
            <li><b>9) Typed Spell/Maneyver 40</b></li>
            <li><b>10) Fighter Perk 125</b></li>
            <li><b>11) Metamagic Feat 125</b></li>
            <li><b>12) Typed Feat 125</b></li>
            <li><b>13) E+ Perk 150</b></li>
            <li><b>14) E+ Stats 75</b></li>
            <li><b>15) Resurrective 75</b></li>
            <li><b>16) Level Up 225</b></li>
            <li><b>17) 4-8 Typed Potions 50</b></li>
            <li><b>18) E+ Stats 75</b></li>
            <li><b>S1) Small Gold Pile: </b> If players pick up this gold after failing AoI2 they must make a DC 26 will save or are cursed for the rest of the map, taking a -4 to all d20 rolls.</li>
            <li><b>L1) Large Gold Pile: </b> Appears if players succeed AoI2 check.</li>
        </ul>
        <br/><br/>
        <h4>Areas of Interest: </h4>
        <ul>
            <li><b>1) Spike Trap: </b> If players walk within 20 feet in front of the wall it slams shut, dealing 10d6 piercing damage, and are pinned against the opposite wall until they can make a DC 26 escape artist or DC 40 CMB check. A reflex save dc 26 halves the damage and negates the pinning effect. They can detect the trap DC 39 perception, and disable it DC 31.</li>
            <li><b>2) Shrine to an Old God: </b> Players can roll a knowledge religion DC 39 to appease the shrine, if they succeed they gain access to treasure 1 and L1. If they fail by 10 or less they are aware that this gold is cursed and without the propper ritual it will curse them. If they pick up gold marked S1 anyway they must make a will save DC 26 or be cursed for the rest of the map receiving -4 to all d20 rolls.</li>
        </ul>
        <br/><br/>
    </div>
</template>
            
<script>
import {
VRow,
VCol,
} from "vuetify/lib";
export default {
  components: {    
    VRow,
    VCol,
  },
  data(){
    return{
        
    }
  },
  methods:{

  }
}
</script>